<script lang="ts">
	import type { ISbStoryData } from '@storyblok/js';
	import { editable } from '../editable';
	import Blok from '../blok.svelte';

	interface Props {
		content: ISbStoryData<{
			left: number;
			right: number;
			desktop_left: number;
			desktop_right: number;
			body: ISbStoryData[];
		}>['content'];
	}

	let { content }: Props = $props();

	let marginVars = $derived(
		`--left: ${content.left || 0}px; --right: ${
			content.right || 0
		}px; --desktop-left: ${content.desktop_left || 0}px; --desktop-right: ${
			content.desktop_right || 0
		}px;`
	);
</script>

<div use:editable={content} class="sb-margin" style={marginVars}>
	{#each content.body as block}
		<Blok content={block} />
	{/each}
</div>

<style lang="scss">
	:global(.sb-margin) {
		margin-left: var(--left);
		margin-right: var(--right);

		@media (min-width: 1024px) {
			margin-left: var(--desktop-left);
			margin-right: var(--desktop-right);
		}
	}
</style>
